import _ from 'lodash';

export default {
  data() {
    return {
      // discountData: {
      //   name: "",
      //   frontWebShow: false,
      //   frontWebContent: "",
      //   time: {
      //     startTime: new Date(this.$moment()),
      //     endTime: new Date(this.$moment().add("month", 1)),
      //   },

      //   useModel: "inTime",
      //   limitModel: "payFull",
      //   limitType: "grandTotal",
      //   totalThenDiscount: false,
      //   anyThenDiscount: false,
      //   payFullLimit: "buyCount",
      //   payFullModel: "realNumber",
      //   payFullDiscount: [{
      //     limit: "",
      //     value: ""
      //   }, {
      //     limit: "",
      //     value: ""
      //   }, {
      //     limit: "",
      //     value: ""
      //   }],
      //   payFullUse: false,
      //   payFullCode: ""
      // },

      addPurchaseList: [{
        name: "test"
      }],

      // dis_temp_data: {},
    };
  },
  methods: {
    toExtraSetting() {
      this.$router.push('/shoppingCart/plus');
    },
    toFulldis() {
      this.$router.push('/shoppingCart/fullDiscount');
    },
    autoDiscountCode() {
      this.$store.dispatch("cart/autoDiscountCode").then((data) => {
        this.discountData.payFullCode = data;
      });
    },
    saveDiscountSetting() {
      console.log(this.discountData);
      this.$store.dispatch("cart/cartDiscountSave", this.discountData);
    }
  },
  computed: {
    discountData: {
      get() {
        console.log(this.$store.state.cart.cartDiscoundData);
        return this.$store.state.cart.cartDiscoundData;
      }
    },
    lang: {
      get() {
        return this.$store.state.Public.langtext;
      },
    },
    discountRange() {
      const discountRange = [];
      for (let i = 9.9; i > 0.0; i -= 0.1) {
        discountRange.push({
          value: i.toFixed(1),
          text: i.toFixed(1),
        });
      }
      return discountRange;
    },
    buyfullDisData: {
      get() {
        return this.$store.state.discount.buyfullDisData;
      },
    },
  },
  created() {
    this.$store.dispatch("cart/getCartDiscount", this.$route.params.uid)
  },
};
